import {useEffect} from 'react';

import {logger} from '#logger';

export const useRefreshAuth = (passportHost: string) => {
    useEffect(() => {
        const refreshAuth = async () => {
            try {
                await fetch(new URL('/auth/update/', passportHost).href, {
                    credentials: 'include',
                    mode: 'no-cors',
                });
            } catch (error) {
                const normalizedError = error instanceof Error
                    ? error
                    : new Error(String(error));
                logger.warn(
                    {message: 'Error refreshing Passport auth'},
                    normalizedError,
                );
            }
        };
        const timeoutId = window.setTimeout(refreshAuth, 2_000);
        const intervalId = window.setInterval(refreshAuth, 20 * 60 * 1_000);

        return () => {
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
        };
    }, [passportHost]);
};
